import { useLoginReport } from './hooks';
import { LoginReportPresentation } from './presentations';

export const LoginReport: React.FC = () => {
  const {
    state: { rows, currentPage, totalPage, totalCount, isLoading },
    actions: { handlePageChange, handleSort, handleOutputCsv },
  } = useLoginReport();

  return (
    <LoginReportPresentation
      rows={rows}
      currentPage={currentPage}
      totalPage={totalPage}
      totalCount={totalCount}
      itemCount={rows.length}
      isLoading={isLoading}
      onPageChange={handlePageChange}
      onSort={handleSort}
      onOutputCsv={handleOutputCsv}
    />
  );
};
